// extracted by mini-css-extract-plugin
export default {"badges":"ProductDetailSlideBadges_badges__tCej-","badge":"ProductDetailSlideBadges_badge__qAc5Z","badgeSalePercent":"ProductDetailSlideBadges_badgeSalePercent__t8zgn"};